import { EvaluationDetail, StatusNode } from 'lib/api/decisionEngine/types';

export type EvaluationDetailExtended = EvaluationDetail & { state?: string };

export type NodeResult = {
  status?: 'WAITING' | 'COMPLETED' | 'FAILED';
  result: boolean | null;
  nodeName: string;
  resultText: string | null;
  statusNode: StatusNode | null;
  nodeIdDecision: number | null;
  subDecisionEngineRevisionStory: NodeResult[] | null;
};

export const isNodeWaiting = (node: NodeResult): boolean =>
  node.status === 'WAITING';

export const isNodeFailed = (node: NodeResult): boolean =>
  node.status === 'FAILED';
